import { DataGridPro, GridRowParams, GridSortModel, GridValidRowModel } from '@mui/x-data-grid-pro';
import { SimpleDataGridProps } from './types';
import { useMemo } from 'react';

/**
 *
 */
export default function SimpleDataGrid<T extends GridValidRowModel>(props: SimpleDataGridProps<T>) {
	const onRowClick = (params: GridRowParams<T>) => {
		if (props.selectOptions?.onRowSelect) {
			props.selectOptions.onRowSelect(params.row);
		}
	};

	const defaultSortByFirstColumn = useMemo<GridSortModel>(() => [{ field: props.columns[0].field, sort: 'asc' }], [props]);

	return (
		<DataGridPro
			columns={props.columns}
			rows={props.rows}
			onRowClick={onRowClick}
			slotProps={{
				toolbar: {
					csvOptions: { disableToolbarButton: true },
					printOptions: { disableToolbarButton: true }
				}
			}}
			sortModel={defaultSortByFirstColumn}
			disableColumnSelector
		/>
	);
}
